<div class="p-4">
<!--  <ngx-json-viewer *ngIf="!!json" [json]="json" [depth]="1"></ngx-json-viewer>-->
</div>
